<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Settings'" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>
	<div class="kt-portlet__body">
		<mat-tab-group>
			<mat-tab label="Calibrations"> <kt-calib-settings></kt-calib-settings> </mat-tab>
			<mat-tab label="Settings"> <kt-shadow-settings></kt-shadow-settings> </mat-tab>
		  </mat-tab-group>
	</div>
</div>
